import React from "react";
import { FoundUser } from "..";
import user from "../../../../assets/png/userd-demo-pic.png";

interface StepProps {
  children: React.ReactElement;
  active?: boolean;
  found?: FoundUser;
}

const Step: React.FC<StepProps> = (props) => {
  return (
    <div
      className={`flex flex-col ${
        props.active ? "opacity-100" : "pointer-events-none opacity-50"
      }`}
    >
      {!props.found ? (
        <>{props.children}</>
      ) : (
        <div className="flex flex-[0.7] flex-col items-center justify-center">
          <p className="font-bold">USUÁRIO ENCONTRADO</p>
          <span />
          <div className="flex w-full items-center rounded-full border border-zinc-300 p-2">
            <img
              src={user}
              alt="User Avatar"
              className="aspect-square h-12 w-12"
            />
            <div className="ml-5 flex flex-col">
              <p>{props.found.name}</p>
              <p>{props.found.phone.slice(0, 4)}*******</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Step;
